// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___1z2hD","illustration":"styles-module__illustration___2DnPo","title":"styles-module__title___1zyYU"};